import * as auditService from '../services/audit';
import { Modal } from 'antd';
import { PATHS } from '../utils/constants';

export default {
  namespace: 'meetingAudit',
  state: {
    list: [],
    total: 0,
    current: 1,
    pageSize: 10
  },
  reducers: {
    update(state, { payload }) {
      return { ...state, ...payload };
    }
  },
  effects: {
    *getAuditMeetings(_, { select, put, call }) {
      const { pageSize, current } = yield select(state => state.meetingAudit);
      const { data, status, msg } = yield call(auditService.getAuditMeetings, {
        pageSize,
        pageNo: current
      });
      if (status === 0) {
        yield put({
          type: 'update',
          payload: { ...data, current: data.pageNo }
        });
      } else {
        Modal.error({ content: msg });
      }
    },
    *auditMeeting(
      { meetingId, auditStatus, remark = '' },
      { select, put, call }
    ) {
      const { locale: lang, messages } = yield select(state => state.i18n);
      const { status, msg } = yield call(auditService.auditMeeting, {
        meetingId,
        status: auditStatus,
        remark,
        lang
      });
      if (status === 0) {
        yield put({ type: 'getAuditMeetings' });
      } else {
        Modal.error({
          title: messages.meeting_audit_fail_title,
          content: msg
        });
      }
    }
  },
  subscriptions: {
    setup({ dispatch, history }) {
      return history.listen(({ pathname }) => {
        if (pathname === PATHS.meetingAudit) {
          dispatch({ type: 'getAuditMeetings' });
        }
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/models/meetingAudit.js